import { Reducer } from 'redux'
import { ICarrierResponsePayload } from 'types/carrier'
import { ICarrierState } from 'apps/booking/types'
import {
  FETCH_CARRIER_ACTION_TYPES as c,
  CARRIER_ACTIONS as d,
} from 'apps/booking/utils/actions/carrier'

const initState: ICarrierState = {
  data: undefined,
  loading: false,
  error: '',
}

export type CarrierActions =
  | { type: c.FETCH_CARRIER_REQUEST }
  | { type: c.FETCH_CARRIER_SUCCESS; payload: ICarrierResponsePayload }
  | { type: c.FETCH_CARRIER_FAILURE; errorMessage: string }
  | { type: d.CLEAR_CARRIER_DATA }

const carrierReducer: Reducer<ICarrierState, CarrierActions> = (
  state: ICarrierState = initState,
  action: CarrierActions
): ICarrierState => {
  switch (action.type) {
    case c.FETCH_CARRIER_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case c.FETCH_CARRIER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.carrierApplication,
      }
    case c.FETCH_CARRIER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.errorMessage,
      }
    case d.CLEAR_CARRIER_DATA:
      return {
        ...state,
        ...initState,
      }
    default:
      return state
  }
}

export default carrierReducer
